import apiClient from '@/shared/services/api/apiClient';

export const getJobs = async (params: Record<string, any> = {}) => {
  // console.log("job api called")
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined
    )
  );

  const { data } = await apiClient.get('/jobs/public', {
    params: cleanParams,
  });



  return data.data;
};

export const getDashboardJobs = async (params: Record<string, any> = {}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined
    )
  );

  const { data } = await apiClient.get('/jobs/getJobs', {
    params: cleanParams,
  });

  return data.data;
};

export const getJobById = async (jobId: string) => {
  const { data } = await apiClient.get(`/jobs/${jobId}`);

  return data.data;
};

export const createJob = async (job: Record<string, any>) => {
  const { data } = await apiClient.post('/jobs/createJob', job);

  return data.data;
};

export const updateJob = async (jobId: string, updates: Record<string, any>) => {
  const { data } = await apiClient.put(`/jobs/${jobId}`, updates);

  return data.data;
};

export const updateJobStatus = async (jobId: string, status: string) => {
  const { data } = await apiClient.patch(`/jobs/${jobId}/status`, {
    status,
  });

  return data.data;
};

export const deleteJob = async (jobId: string) => {
  const { data } = await apiClient.delete(`/jobs/${jobId}`);

  return data.data;
};


export const getPendingJobApprovals = async () => {
  const { data } = await apiClient.get('/jobs/approvals/pending');
  return data.data;
};


export const getJobApprovalRequestById = async (requestId: string) => {
  const { data } = await apiClient.get(
    `/jobs/approvals/requests/${requestId}`
  );

  return data.data;
};

export const getMyJobApprovalRequestById = async (
  requestId: string
) => {
  const { data } = await apiClient.get(
    `/jobs/approvals/my-requests/${requestId}`
  );

  return data.data;
};


export const approveJobRequest = async (
  requestId: string,
  comments?: string
) => {
  const { data } = await apiClient.post(
    `/jobs/approvals/requests/${requestId}/approve`,
    { comments }
  );

  return data.data;
};

export const rejectJobRequest = async (
  requestId: string,
  reason: string
) => {
  const { data } = await apiClient.post(
    `/jobs/approvals/requests/${requestId}/reject`,
    { reason }
  );

  return data.data;
};

export const requestJobChanges = async (
  requestId: string,
  comments: string
) => {
  const { data } = await apiClient.post(
    `/jobs/approvals/requests/${requestId}/request-changes`,
    { comments }
  );

  return data.data;
};

export const createJobShareLink = async (jobId: string) => {
  const { data } = await apiClient.post(
    `/jobs/${jobId}/share`
  );

  return data.data;
};
